import React from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./Unified_Ledger.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const Header = ({ STATUSES, status, setStatus }) => {
  const navigate = useNavigate();
  return (
    <div className={Styles.bankingSearchHead}>
      <div className={Styles.bankingLedgerBack}>
        <div
          onClick={() => {
            navigate(-1);
          }}
          className={Styles.receivedBackButton}
        >
          <ArrowBackIosIcon
            style={{ width: "10px", height: "10px", paddingRight: "5%" }}
          />
          Back
        </div>
        <div className={Styles.receivedHeading}>Ongoing Connections</div>
      </div>
      <div className={Styles.tabs}>
        {STATUSES.map((s) => (
          <button
            key={s}
            onClick={() => setStatus(s)}
            aria-pressed={s === status}
            className={`${Styles.tab} ${s === status ? Styles.tabActive : ""}`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Header;
